/* eslint-disable */

export const dateDividers = {
  DASH: "-",
  BAR: "/"
}

export const getTodayDate = () => {
  let day = `${new Date().getDate()}`;
  let month = `${new Date().getMonth() + 1}`;
  let year = `${new Date().getFullYear()}`;

  if (day.length == 1) day = "0" + day;
  if (month.length == 1) month = "0" + month;

  return `${day}/${month}/${year}`;
};

export const getFirstDayOfTheMonth = () => {
  let day = `01`;
  let month = `${new Date().getMonth() + 1}`;
  let year = `${new Date().getFullYear()}`;

  if (day.length == 1) day = "0" + day;
  if (month.length == 1) month = "0" + month;

  return `${day}/${month}/${year}`;
};

export const lastDayOfTheMonth = (month) => {
  if (
    month == 1 ||
    month == 3 ||
    month == 5 ||
    month == 7 ||
    month == 8 ||
    month == 10 ||
    month == 12
  )
    return 31;
  else if (month == 4 || month == 6 || month == 9 || month == 11) return 30;
  else return 29;
};

export const reverseMaskDate = (date, divider = dateDividers.BAR, join = dateDividers.DASH) => {
  let buff = "";
  const dateArray = date.split(divider);
  buff = dateArray[2];
  dateArray[2] = dateArray[0];
  dateArray[0] = buff;
  let temp = "";
  temp += dateArray.join(join);
  return temp;
};
